import { observer } from "mobx-react-lite"

const NotFound = () => {
    return (
        <div className="notFound">
            <div className="content">
                <div className="code">404</div>
                <div className="title">Упс! Кажется, вы заблудились...</div>
                <div className="subTitle">Эта страница отправилась в космос, переехала <br />или просто исчезла.</div>
                <div className="answer_title">Не переживайте - вы можете</div>
                <div className="buttons">
                    {/* <button className="activeButton" onClick={() => {window.history.go(-1); return false;}}>Вернуться</button> */}
                    <button className="activeButton" onClick={() => {window.location.replace("/calc")}}>Вернуться</button>
                    <button className="activeButton disabled">Написать нам, если что-то сломалось</button>
                </div>
                <div className="answer_subTitle">Или просто улыбнуться и попробовать ещё раз :)</div>
            </div>
        </div>
    )
}

export default observer(NotFound);
